import { useMutation } from '@tanstack/react-query'
import { useUserData } from 'auth'
import Loading from 'components/Loading'
import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useTRPC } from 'utils/trpc'

export const DocusignConnectionResponse = () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()

    const state = searchParams.get('state')

    useEffect(() => {
        navigate(`/${state}/docusign/auth?${searchParams.toString()}`)
    }, [])

    return <Loading />
}

export const LoggedInDocusignConnectionResponse = () => {
    const navigate = useNavigate()
    const trpc = useTRPC()
    const { refreshUser } = useUserData()
    const [searchParams] = useSearchParams()

    const code = searchParams.get('code')
    const setTokenMutation = useMutation(trpc.docusignSettings.setToken.mutationOptions())

    const setToken = async () => {
        if (!code) return
        await new Promise(r => setTimeout(r, 100))
        await setTokenMutation.mutateAsync({ code })
        await refreshUser()
        navigate(`../../usersettings`, {
            replace: true,
            relative: 'path',
        })
    }

    useEffect(() => {
        setToken()
    }, [])

    return <Loading />
}
